export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ax = { withCredentials: true };

// FastAPI returns `detail` as a string, or a list for validation errors.
export function errorText(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return fallback;
}

export const WAREHOUSE_CAPABILITIES = ["SENDER", "RECEIVER"];
// eBay is added here once its module exists; the backend rejects it until then.
export const MARKETPLACES = ["AMAZON_FBA"];
